import QueryWhereLeftBracket from '../../../query/remote/QueryWhereLeftBracket';
import QueryWhereRightBracket from '../../../query/remote/QueryWhereRightBracket';
import StringUtil from '../../../utils/StringUtil';

export default class ValueCondition
{
	remoteClass = "gongqi.erp.gotmodel.form.remote.ValueCondition";
	items;
	_sqlWhereStr;
	static getSqlWhereStr()
	{
		//TODO  这个类应删除掉，改为RecordConditionTask
		if(this.sqlWhereStr)
			return _sqlWhereStr;
		var result = "";
		var leftBracket = QueryWhereLeftBracket.None;
		var rightBracket = QueryWhereRightBracket.None;
		for(let i=0;i<items.length;i++)		
		{
			let item = items[i];
			
			if(i > 0)
			{
				result += (" " + item.andOr);
			}
			
			
			if(item.leftBracket!=QueryWhereLeftBracket.None)
			{
				result += (" " + QueryWhereLeftBracket.labelOf(item.leftBracket));
				leftBracket += item.leftBracket;
			}
			
			if(item.value == null)
				item.value = "";
			
			if(item.value.indexOf(",") != -1)
				var fieldValues = item.value.split(",");
			else
				fieldValues = [item.value];
			
			if(fieldValues.length > 1)
				result += " (";
			
			for(let j=0;j<fieldValues.length;j++)
			{
				let _fv = fieldValues[j];
				
				if(j > 0)
				{
					result += (" or " + ".fieldName"+"="+StringUtil.trimThrough(_fv));	
				}
				else
				{
					result += (" "+".fieldName"+"="+StringUtil.trimThrough(_fv));
				}
			}
			
			if(fieldValues.length > 1)
				result += " )";
			
			//if(item.rightBracket != 0)
			//	item.rightBracket = 0;
			
			if(item.rightBracket!=QueryWhereRightBracket.None)
			{
				result += (" " + QueryWhereRightBracket.labelOf(item.rightBracket));
				rightBracket += item.rightBracket;
			}
		}
		
		if(leftBracket != rightBracket)
		{
			//GongqiAlert.show("括号不匹配");
			return "";
		}
		
		this._sqlWhereStr = result;
		return result;
	}
	
}



// WEBPACK FOOTER //
// ./src/forms/sys/remote/ValueCondition.js